/*global window, jQuery */
(function($) {
   'use strict';


    $('.guarda_tutte').on('click', function(){
      $('.galleria_0').trigger('click');
    });

    $(".owl-carousel").owlCarousel({
      margin: 0,
      loop: false,
      items: 3,
      stagePadding: 100,
      responsive : {
          // breakpoint from 0 up
          0 : {
              items: 1,
          },
          
          // breakpoint from 768 up
          768 : {
              items: 2,
          },
          1600 : {
              items: 3,
          }
      }
    });

}(jQuery));